import { ErrorType } from "const";

export const isMissingTaxIdError = (errorCode) => {
  return errorCode === ErrorType.TAX_ID_MISSING_1 || errorCode === ErrorType.TAX_ID_MISSING_2;
};

export const isSystemCloseError = (errorCode) => {
  return errorCode === ErrorType.SystemClose;
};
